import { Connection, IConnection } from './connection';
import { Observable } from 'rxjs';



/**
 * Clase para realizar la conexión Http con el back-end.
 *
 * @export
 * @class HttpConnection
 * @extends {Connection}
 */
export class HttpConnection extends Connection {


    /**
     * Crea la instancia de HttpConnection.
     *
     * @param {IConnection} target
     * @memberof HttpConnection
     */
    constructor(target: IConnection) {
        super(target);
    }


    /**
     * Devuelve el tipo de conexión
     *
     * @returns {string}
     * @memberof HttpConnection
     */
    public getType(): string{
        return this.target.getType();
    }


    public getOperators(): Observable<Array<string>> {
        return this.target.getOperators();
    }


    /**
     * Pide el cambio de usuario mediante una petición http.
     *
     * Devuelve el observable de la respuesta.
     *
     * @param {string} [code='']
     * @returns {Observable<any>}
     * @memberof HttpConnection
     */
    public cambiarOperario(code: string = ''): Observable<any> {
        return this.target.cambiarOperario(code);
    }

    /**
     * Pide la orden de fabricación del usuario mediante una petición http.
     *
     * Devuelve el observable de la respuesta.
     *
     * @param {string} [code='']
     * @param {string} [operator='']
     * @returns {Observable<any>}
     * @memberof HttpConnection
     */
    public cambiarOf(code: string = '', operator: string = '', coord = ''): Observable<any> {
        return this.target.cambiarOf(code, operator, coord);
    }

    /**
     * Pide la entrada/salida del operario mediante una petición http.
     *
     * Devuelve el observable de la respuesta
     *
     * @param {string} [operator='']
     * @returns {Observable<any>}
     * @memberof HttpConnection
     */
    public entrarOperario(operator: string = '', coord = ''): Observable<any> {
        return this.target.entrarOperario(operator, coord);
    }

    /**
     * Pide la salida del operario mediante una petición http.
     *
     * Devuelve el observable de la respuesta
     *
     * @param {string} [operator='']
     * @returns {Observable<any>}
     * @memberof HttpConnection
     */
    public salirOperario(operator: string = '', coord = ''): Observable<any> {
        return this.target.salirOperario(operator, coord);
    }

    /**
     * Pide la lista de OFs interna mediante una petición http.
     *
     * Devuelve el observable de la respuesta.
     *
     * @returns {Observable<any>}
     * @memberof HttpConnection
     */
    public listaOfsInternas(): Observable<any>{
        return this.target.listaOfsInternas();
    }

    /**
     * Pide las fichadas de un operador en una determinada fecha mediante petición http.
     *
     * Devuelve el observable de la respuesta.
     *
     * @param {string} [operator='']
     * @param {string} [date='']
     * @returns {Observable<any>}
     * @memberof HttpConnection
     */
    getOfsOperario(operator: string = '', date: string = ''): Observable<any>{
        return this.target.getOfsOperario(operator, date);
    }

    getInformeTest(date1: string = '', date2: string = ''): Observable<any>{
      return this.target.getInformeTest(date1, date2);
    }

    /**
     * Pide los productos de una orden de fabricación mediante petición http.
     *
     * Devuelve el observable de la respuesta.
     *
     * @param {string} [of='']
     * @returns {Observable<any>}
     * @memberof HttpConnection
     */
    getProductosOfDropdown(of: string = ''): Observable<any>{
        return this.target.getProductosOfDropdown(of);
    }

    /**
     * Pide las operaciones de un producto mediante petición http.
     *
     * Devuelve el observable de la respuesta.
     *
     * @param {string} product
     * @returns {Observable<any>}
     * @memberof HttpConnection
     */
    getOpsProdOfDropdown(product: string): Observable<any>{
        return this.target.getOpsProdOfDropdown(product);
    }

    /**
     * Pide la modificación de horas de una fichada mediante petición http
     *
     * Devuelve el observable de la respuesta.
     *
     * @param {string} [register=''] El id de registro
     * @param {*} clockIn Los parámetros necesarios
     * @returns {Observable<any>}
     * @memberof HttpConnection
     */
    modHorasOpProdOf(register: string  ='', clockIn: any): Observable<any>{
        return this.target.modHorasOpProdOf(register, clockIn);
    }


    /**
     * Pide añadir horas de una fichada mediante petición http.
     *
     * Devuelve el observable de la respuesta.
     *
     * @param {*} [clockIn={}]
     * @returns {Observable<any>}
     * @memberof HttpConnection
     */
    anadirHorasOpProdOf(clockIn: any = {}): Observable<any>{
        return this.target.anadirHorasOpProdOf(clockIn);
    }

    /**
     * Pide eliminar el registro de una fichada mediante petición http.
     *
     * Devuelve el observable de la respuesta.
     *
     * @param {string} [register='']
     * @returns {Observable<any>}
     * @memberof HttpConnection
     */
    delHorasOpProdOf(register: string = ''): Observable<any>{
        return this.target.delHorasOpProdOf(register);
    }

    /**
     * Pide los parámetros de configuración del sistema.
     *
     * @returns {Observable<any>}
     * @memberof HttpConnection
     */
    getParams(): Observable<any>{
        return this.target.getParams();
    }

    /**
     * Pide el logo.
     *
     * @returns {Observable<any>}
     * @memberof HttpConnection
     */
    getLogo(): Observable<any>{
        return this.target.getLogo();
    }

    /**
     * Realiza el login.
     *
     * @returns {Observable<any>}
     * @memberof HttpConnection
     */
    login(credentials: {username:string, password:string} = {username:'',password:''}): Observable<any>{
        return this.target.login(credentials);
    }

    /**
     * Pide el nombre de operario.
     *
     * @returns {Observable<any>}
     * @memberof HttpConnection
     */
    operario(operator: string = ''): Observable<any>{
        return this.target.operario(operator);
    }

    /**
     * Establece el token de autenticación.
     *
     * @param {string} [token='']
     * @memberof HttpConnection
     */
    setToken(token: string = ''){
        this.target.setToken(token);
    }
}



// WEBPACK FOOTER //
// ./src/modules/sbsuite/models/connection/http-connection.ts